export default __webpack_public_path__ + "static/media/Phone.4b10fb60.svg";